window.addEventListener('SITE_START', () => {
  const $accordions = document.querySelectorAll('.accordion');
  $accordions.forEach(acc => {
    const isSingle = (acc.dataset.accordion || '').toLowerCase() === 'single'; // 하나만 열림

    // 초기 상태
    acc.querySelectorAll('.accordion__item').forEach(item => {
      const panel = item.querySelector('[data-accordion-bottom]');
      const shouldOpen = item.classList.contains('is-open');
      if (shouldOpen) {
        item.classList.add('is-open');
        gsap.set(panel, { height: 'auto' });
      } else {
        item.classList.remove('is-open');
        gsap.set(panel, { height: 0 });
      }
    });

    // 클릭 토글
    const onToggle = (e) => {
      const head = e.target.closest('[data-accordion-head]');
      if (!head || !acc.contains(head)) return;

      const item  = head.closest('.accordion__item');
      const panel = item.querySelector('[data-accordion-bottom]');
      const willOpen = !item.classList.contains('is-open');

      if (isSingle && willOpen) {
        acc.querySelectorAll('.accordion__item.is-open').forEach(openItem => {
          if (openItem !== item) closeItem(openItem);
        });
      }

      willOpen ? openItem(item) : closeItem(item);
    };

    acc.addEventListener('click', onToggle);

    function openItem(item) {
      const panel = item.querySelector('[data-accordion-bottom]');
      item.classList.add('is-open');
      gsap.killTweensOf(panel);
      gsap.to(panel, { height: 'auto', duration: 0.3 });
    }

    function closeItem(item) {
      const panel = item.querySelector('[data-accordion-bottom]');
      item.classList.remove('is-open');
      gsap.killTweensOf(panel);
      const current = panel.offsetHeight;
      gsap.fromTo(panel, { height: current }, { height: 0, duration: 0.3 });
    }
  });
});

// 임시 찾아오시는 길 아코디언
window.addEventListener('SITE_START', () => {
  const $accordions = document.querySelectorAll('[data-accordion]');
  $accordions.forEach(acc => {
    const isSingle = (acc.dataset.accordion || '').toLowerCase() === 'single'; // 하나만 열림

    // 초기 상태
    acc.querySelectorAll('[data-accordion-item]').forEach(item => {
      const panel = item.querySelector('[data-accordion-bottom]');
      const shouldOpen = item.classList.contains('is-open');
      if (shouldOpen) {
        item.classList.add('is-open');
        gsap.set(panel, { height: 'auto' });
      } else {
        item.classList.remove('is-open');
        gsap.set(panel, { height: 0 });
      }
    });

    // 클릭 토글
    const onToggle = (e) => {
      const head = e.target.closest('[data-accordion-head]');
      if (!head || !acc.contains(head)) return;

      const item  = head.closest('[data-accordion-item]');
      const panel = item.querySelector('[data-accordion-bottom]');
      const willOpen = !item.classList.contains('is-open');

      if (isSingle && willOpen) {
        acc.querySelectorAll('[data-accordion-item].is-open').forEach(openItem => {
          if (openItem !== item) closeItem(openItem);
        });
      }

      willOpen ? openItem(item) : closeItem(item);
    };

    acc.addEventListener('click', onToggle);

    function openItem(item) {
      const panel = item.querySelector('[data-accordion-bottom]');
      item.classList.add('is-open');
      gsap.killTweensOf(panel);
      gsap.to(panel, { height: 'auto', duration: 0.3 });
    }

    function closeItem(item) {
      const panel = item.querySelector('[data-accordion-bottom]');
      item.classList.remove('is-open');
      gsap.killTweensOf(panel);
      const current = panel.offsetHeight;
      gsap.fromTo(panel, { height: current }, { height: 0, duration: 0.3 });
    }
  });
});
